export enum PlantMaterialStatus {
    D = "D",
    S = "S",
    N = "N",
}
